import { ModalHeader } from "@/components/Modal";
import Modal from "@/components/Modal/Modal";
import clsx from "clsx";
import { useToggle, useWindowSize } from "react-use";

export const Certificate = () => {
  const [showModal, toggleModal] = useToggle(false);

  return (
    <div>
      <div
        className={clsx(
          "group",
          "relative",
          "h-80 w-80 tablet:h-[336px] tablet:w-[336px] desktop:h-[396px] desktop:w-[396px]",
          "",
          "flex justify-center overflow-hidden rounded-full",
          "bg-gradient-to-t from-[#A1CCEE] to-[#EDF7FF]",
        )}
      >
        <div className="mt-16 desktop:mt-[88px]">
          <img src="/images/about-us-certificate.jpeg" className="w-60 rounded-lg object-cover desktop:w-[300px]" />
        </div>
        <div
          className="absolute inset-0 items-center justify-center bg-[#3A424A] opacity-0 transition-opacity duration-300 group-hover:flex group-hover:opacity-80"
          role="button"
          onClick={toggleModal}
        >
          <div></div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            fill="none"
            viewBox="0 0 24 24"
            className="text-white"
          >
            <circle
              cx="11.766"
              cy="11.766"
              r="8.989"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            ></circle>
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M18.018 18.485L21.542 22"
            ></path>
          </svg>
        </div>
      </div>
      {showModal && <CertificateModal onClose={toggleModal} />}
    </div>
  );
};

interface CertificateModalProps {
  onClose: () => void;
}

const CertificateModal = ({ onClose }: CertificateModalProps) => {
  const size = useWindowSize();
  const modalWidth = size.width > size.height ? size.height * 0.8 * 0.706 : size.width * 0.8;

  return (
    // TODO: change modal to modalComponent
    <Modal open={true} onClose={onClose}>
      <div style={{ width: modalWidth }}>
        <ModalHeader onClose={onClose} />
        <img src="/images/about-us-certificate.jpeg" className="-mt-8 w-full shrink-0" />
      </div>
    </Modal>
  );
};
